module.exports = __webpack_public_path__ + "img/content_image2.42ee7488.png";